import { useParams } from "react-router-dom";
import CsvUploadForm from "../common/components/CsvUploadForm";
import ResultFormLayout from "./components/ResultFormLayout";
import { useResultForm } from "./hooks/useResultForm";

const RegisterResult = () => {
  let { id: serialNumber } = useParams();
  const {
    selectedOption,
    setSelectedOption,
    formErrors,
    loading,
    submit,
    handleOnChange,
  } = useResultForm(serialNumber, { loadExisting: false });

  return (
    <ResultFormLayout
      serialNumber={serialNumber}
      heading={`Result registration for semen analysis kit ${serialNumber}`}
      primaryLabel="Save & close"
      selectedOption={selectedOption}
      setSelectedOption={setSelectedOption}
      formErrors={formErrors}
      loading={loading}
      onSubmit={submit}
      onCancel={() => globalThis.history.back()}
      onChangeOption={handleOnChange}
      topContent={<CsvUploadForm />}
    />
  );
};

export default RegisterResult;
